export default __webpack_public_path__ + "static/media/img-4634.3488b00f.jpeg";